import Vue from "vue";


const solutions = {
    namespaced: true,
    state: {
        selectedVehicle: {},
        selectedManufacturerId: null,
        selectedModelId: null,
        selectedYear: null,
        selectedBodyTypeId: null,
        selectedCulture: null,
        manufacturersCount: null,
    },
    mutations: {
        setSelectedVehicle(state, selectedVehicle) {
            state.selectedVehicle = selectedVehicle;

            // set cookie for backend to use
            let vehicleId = selectedVehicle.vehicleId || null;
            Vue.cookie.set("user_vehicle_id", vehicleId, 1);
        },
        storeManufacturerId(state, manufacturerId) {
            state.selectedManufacturerId = manufacturerId;
        },
        storeModelId(state, modelId) {
            state.selectedModelId = modelId;
        },
        storeYear(state, year) {
            state.selectedYear = year;
        },
        storeBodyTypeId(state, bodyTypeId) {
            state.selectedBodyTypeId = bodyTypeId;
        },
        storeCulture(state, culture) {
            state.selectedCulture = culture;
        },
        storeManufacturersCount(state, count) {
            state.manufacturersCount = count;
        },
        resetSelectedHistory(state) {
            state.selectedManufacturerId = null;
            state.selectedModelId = null;
            state.selectedYear = null;
            state.selectedBodyTypeId = null;
            state.selectedCulture = null;
            state.manufacturersCount = null;
        }
    },
    getters: {}
};

export default solutions;
